export const PROJECT_CODE = 'CREDIT_FLOW'
export const UNDERWRITER = 'UNDERWRITER'
export const HEAD_UNDERWRITER = 'HEAD_UNDERWRITER'
export const SUPER_UNDERWRITER = 'SUPER_UNDERWRITER'
export const MANAGER = 'MANAGER'
export const CREDIT_ADMIN = 'CREDIT_ADMIN'
export const ACCOUNTANT = 'ACCOUNTANT'
export const DICT_ADMIN = 'DICT_ADMIN'
